;(function($, undefined){
    var rnn,
        log,
        form,
        locationPickerWidget,
        addFormFieldLabels,
        addFormCookieName;

    function setAddFormCookie() {
        Cookies.set(addFormCookieName, "success", { path: "/" });
    }

    function getAddFormCookie() {
        return Cookies.get(addFormCookieName);
    }

    function clearAddFormCookie() {
        Cookies.remove(addFormCookieName);
    }

    function setLatLngFields($form, position) {
        $form.find('[name=latitude]').val(position.latitude);
        $form.find('[name=longitude]').val(position.longitude);
    }

    function fireAddressChanged($target, address){
        var addressChangedEvent = $.Event('addresschanged');

        addressChangedEvent.address = address;

        addressChangedEvent.target = $target[0];

        $target.trigger(addressChangedEvent);
    }

    function resetLocationControls($form) {
        var fieldNames = ['street_address', 'locality', 'locality_id', 'latitude', 'longitude'];

        fieldNames.fastEach(function(fieldName){
            $form.find('[name=' + fieldName + ']').val('');
        });

        fireAddressChanged($form.find('[name=street_address]'), '');
    }

    function addressFieldChanged(event){
        var $target = $(event.target),
            $form = $target.closest('.mapArea'),
            $streetAddress = $form.find('[name=street_address]'),
            $locality = $form.find('[name=locality]'),
            streetAddress = $locality.val();

        if ($streetAddress.val()) {
            streetAddress = $streetAddress.val() + ', ' + streetAddress;
        }

        fireAddressChanged($target, streetAddress);
    }

    function submitFormAndHandleAjaxResponse(event) {
        var $target = $(event.target),
            $form = $target.closest('form');

        event.preventDefault();

        function success(response) {
            if (!response.valid) {

                $form.find('.messages')
                    .append(forms.createErrorsAlert($form, response.errors)).end()
                    .find('button').button('reset');
            } else {
                setAddFormCookie();
                window.location.reload();
            }
        }

        function failure() {
           alert('There was an error submitting your notice. It\'s our fault, not yours. Please try again or contact us for support.');
        }

        $form
        .find('button')
            .button('loading')
        .end()
        .find('.alert-success')
            .hide()
        .end()
        .find('.alert-error')
            .hide(function(){
                $(this).remove();
            })
        .end()
        .find('.control-group.error')
            .removeClass('error')
        .end()
        .ajaxSubmit({
            success: success,
            failure: failure,
            dataType: 'json'
        });
    }

    function createMenu(){
        var menu = $($.el.nav({'class':'menu'}, 'Post a notice')),
            doneButton = $($.el.button({'class':'btn closeModal', 'type':'button'}, 'Back'));

        menu.append(doneButton);

        return menu;
    }

    function createForm(settings){
        var titleBox,
            createControlGroup = forms.createControlGroup,
            ugcForm,
            $categoryPicker,
            $locationPicker,
            $typeField,
            $localityField,
            imageUpload;

        ugcForm = $($.el.form({'class': 'postNotice noticeAddForm mapArea', 'method': 'POST', 'action': settings.url},

            $.el.div({'class':'noticeOverlay'},

                $.el.div({'class':'contentWrapper'},

                    // Hidden fields
                    createControlGroup({name:'latitude', type: 'hidden'}),
                    createControlGroup({name:'longitude', type: 'hidden'}),
                    createControlGroup({name:'locality_id', type: 'hidden'}),
                    createControlGroup({name:'parent_content_id', type: 'hidden'}),
                    createControlGroup({name:'parent_content_type_id', type: 'hidden'}),
                    createControlGroup({name:'street_address', placeholder:'Address', title: 'Address', type: 'hidden'}),
                    ($localityField = $(createControlGroup({name:'locality', placeholder:'Suburb, Town, Postcode', title: 'Locality', type: 'hidden'})))[0],


                    $.el.div({"class":"messages"}),

                    //Title
                    titleBox = createControlGroup({name:'title', placeholder:'Title', title: 'Title'}),

                    ($categoryPicker = $($.el.div({'class':'picker'},
                        //Category
                        createControlGroup({name:'type', placeholder:'Choose a catergory', title: 'Type', element: 'select' })
                    )))[0],

                    //Description
                    createControlGroup({element: 'textarea', name:'description', placeholder:'Your Notice...', title: 'Description'}),

                    // Image uploader
                    imageUpload = $.el.div({'class':'imageUpload pull-left margin-right'}),

                    // LocationPicker
                    ($locationPicker = $($.el.div({'class':'locationPickerMap locationPickerWidget', id: parseInt(Math.random() * 1000, 10)})))[0],


                    $.el.button({'type':'submit', 'class':'submit btn btn-primary'}, "Submit your notice")
                )
            )

        ));

        rnn.modules.imageUpload.create(imageUpload, {name:'image'});

        $locationPicker.data('map-marker', {latitude:settings.marker.latitude, longitude:settings.marker.longitude});

        $typeField = ugcForm.find('[name=type]');

        $localityField.data('typeahead-ajax', {
            url: rnn.site.typeaheadURL,
            params: {'types': 'po', 'return': 'id', 'format': 'sensible'},
            target: 'input[name=locality_id]',
            input: $localityField.find('input')
        });

        rnn.modules.forms.lazyTypeAhead($localityField);

        if(settings.noticeTypes['']){
            $typeField.append($.el.option({value: ''}, settings.noticeTypes['']));
        }

        for(var key in settings.noticeTypes){
            if(key === ''){
                continue;
            }
            var option = $.el.option({value: key}, settings.noticeTypes[key]);
            $typeField.append(option);
        }

        rnn.modules.optionPicker.create($categoryPicker);

        return ugcForm;
    }

    function createSuccessMessage(){
        return rnn.modules.alert.show(null, {
            message: $.el.span('Your notice was postesd successfully, ',
                $.el.br(),
                $.el.a({href: rnn.site.noticeboardURL}, "View it on the Notice Board")
            ),
            title: 'Success',
            type: 'success'
        });
    }

    function onPostSuccess(){
        var $form = $(this),
            settings = rnn.getModule($form, 'notice').data('module'),
            $newForm = createForm(settings);

        $form.replaceWith($newForm);
        locationPickerWidget.create($newForm.find('.locationPickerWidget'));
        $newForm.before(createSuccessMessage(settings));
    }

    function createWrapper(){
        return $($.el.div({'class':'mobileNoticeWrapper mobileModal'}, createMenu()[0]));
    }

    function createPostNoticeForm(settings) {
        var $wrapper, $description, $street_address, $locality_id, $latitude, $longitude, $map;


        $wrapper = createWrapper(settings);
        $wrapper.data('module', settings);
        settings.target.after($wrapper);

        var form;

        rnn.modules.user.get(function(user){
            if(!user.authenticated){
                form = rnn.modules.login.createForm('login to share your notice', settings.loginMessage);
            }else{
                form = createForm(settings);
                settings.success = onPostSuccess;
            }

            $wrapper.find('form.login').remove();
            $wrapper.append(form);

        });
        return $wrapper;
    }

    function showPostNotice(settings){
        var postNoticeOverlay = $('body').find('.mobileNoticeWrapper');
        if(!postNoticeOverlay.length){
            postNoticeOverlay = createPostNoticeForm(settings);
            locationPickerWidget.create(postNoticeOverlay.find('.locationPickerWidget'));
        }
        rnn.modules.modal.show(postNoticeOverlay);
    }

    // Initialise Notices
    function initPostNotice() {

        forms = rnn.modules.forms;
        locationPickerWidget = rnn.modules.locationPickerWidget;

        $(rnn).on('login', function(event){
            var $wrapper = $('.mobileNoticeWrapper'),
                settings = $wrapper.data('module');

            if (settings) {
                var form = createForm(settings);

                $wrapper.find('form').replaceWith(form);
                locationPickerWidget.create(form.find('.locationPickerWidget'));
            }
        });

        $(document).on('click', '.showPostNotice', function(){
            var settings = $(this).data('module');
            settings.target = $(this);
            showPostNotice(settings);
        });
    }

    rnn = window.rnn;

    log = rnn.logging.log;

    addFormCookieName = 'noticesAddForm';

    rnn.modules.register('postNotice', {
        init: initPostNotice,
        show: showPostNotice
    });

})(jQuery);
